import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import './SingleSelect.css';

export function SingleSelect({ field, label, optionList, handleChange }) {
    return (
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} error={field.required && !field.selection}>
            {label &&
                <InputLabel>{label + `${field.required ? ' *' : ''}`}</InputLabel>
            }
            <Select
                value={field.selection?.id || ''}
                onChange={(e) => handleChange(field, e.target.value)}
                label={field.selection?.name || ''}
                disabled={field.disabled}
            >
                {
                    optionList
                        .sort((a, b) => a.id - b.id)
                        .map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.name}
                            </MenuItem>
                        ))
                }
            </Select>
        </FormControl>
    );
}